import { Input } from '@/components/common/Input'
import { Textarea } from '@/components/common/Textarea'
import { StepShell, StepGrid } from '../StepShell'

const DEFAULT = {
  previous_extraction: '',
  root_canal_treatment: '',
  orthodontic_treatment: '',
  denture_prosthesis: '',
  last_dental_visit: '',
}

export function DentalHistoryStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 5 — Phase 3"
      title="Dental history"
      description="Prior dental treatment and current prostheses."
    >
      <StepGrid>
        <Textarea
          label="Previous extraction"
          rows={2}
          value={v.previous_extraction}
          onChange={(e) => set({ previous_extraction: e.target.value })}
          placeholder="Tooth no., year"
        />
        <Textarea
          label="Root canal treatment"
          rows={2}
          value={v.root_canal_treatment}
          onChange={(e) => set({ root_canal_treatment: e.target.value })}
          placeholder="Tooth no., year"
        />
        <Textarea
          label="Orthodontic treatment"
          rows={2}
          value={v.orthodontic_treatment}
          onChange={(e) => set({ orthodontic_treatment: e.target.value })}
          placeholder="Braces / aligners, duration"
        />
        <Textarea
          label="Denture / prosthesis"
          rows={2}
          value={v.denture_prosthesis}
          onChange={(e) => set({ denture_prosthesis: e.target.value })}
          placeholder="Type and tooth nos."
        />
        <Input
          label="Last dental visit"
          value={v.last_dental_visit}
          onChange={(e) => set({ last_dental_visit: e.target.value })}
          placeholder="e.g. 6 months ago"
          className="sm:col-span-2"
        />
      </StepGrid>
    </StepShell>
  )
}
